import { Card, Typography } from 'antd';
import { COMPANY, CONTACTS } from '@shared/legal';

const { Title, Text, Paragraph } = Typography;

/**
 * Страница /legal/requisites — реквизиты организации и контакты.
 *
 * Требование ЮKассы для модерации: на сайте должны быть указаны
 * реквизиты вашей организации и контактные данные. Эта страница их и
 * содержит — в табличном формате, легко читается человеком и попадает
 * в индекс поисковиков.
 *
 * LEGAL-OOO: раньше на странице было две секции — Лицензиат (ИП) и
 * Правообладатель (ООО). После перехода приёма платежей на ООО «РИЧ ЧАТ»
 * это одно и то же лицо, поэтому секция одна.
 */

function Row({ label, value }: { label: string; value: React.ReactNode }) {
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: '220px 1fr',
        gap: 16,
        padding: '10px 0',
        borderBottom: '1px solid #F3F4F6',
      }}
    >
      <Text type="secondary" style={{ fontSize: 13 }}>
        {label}
      </Text>
      <Text style={{ fontSize: 14, color: '#1A1A1A' }}>{value}</Text>
    </div>
  );
}

export function LegalRequisitesPage() {
  return (
    <div style={{ maxWidth: 820, margin: '0 auto' }}>
      <Title level={2} style={{ marginTop: 0 }}>
        Реквизиты и контакты
      </Title>
      <Paragraph type="secondary" style={{ fontSize: 14 }}>
        Юридические сведения об организации, предоставляющей сервис RiChat,
        и контактные данные для обращений.
      </Paragraph>

      <Title level={4} style={{ marginTop: 32, marginBottom: 12 }}>
        Организация
      </Title>
      <Card>
        <Row label="Полное наименование" value={COMPANY.fullName} />
        <Row label="ИНН" value={COMPANY.inn} />
        <Row label="КПП" value={COMPANY.kpp} />
        <Row label="ОГРН" value={COMPANY.ogrn} />
        <Row label="Юридический адрес" value={COMPANY.address} />
        <Row label="E-mail" value={COMPANY.email} />
      </Card>

      <Title level={4} style={{ marginTop: 32, marginBottom: 12 }}>
        Банковские реквизиты
      </Title>
      <Card>
        <Row label="Расчётный счёт" value={COMPANY.bankAccount} />
        <Row label="Наименование банка" value={COMPANY.bankName} />
        <Row label="БИК банка" value={COMPANY.bik} />
        <Row label="Корреспондентский счёт" value={COMPANY.corrAccount} />
      </Card>

      <Title level={4} style={{ marginTop: 32, marginBottom: 12 }}>
        Контакты
      </Title>
      <Card>
        <Row
          label="Отдел продаж (Telegram)"
          value={
            <a
              href={CONTACTS.salesTelegram}
              target="_blank"
              rel="noreferrer"
              style={{ color: '#1F2937' }}
            >
              {CONTACTS.salesTelegramLabel}
            </a>
          }
        />
        <Row
          label="E-mail для обращений"
          value={
            <a
              href={`mailto:${CONTACTS.supportEmail}`}
              style={{ color: '#1F2937' }}
            >
              {CONTACTS.supportEmail}
            </a>
          }
        />
      </Card>
    </div>
  );
}
